import React, { useEffect, useState } from 'react';

/** Hora de parede, atualizada a cada 15 s — o suficiente para um relógio sem segundos. */
export function useRelogio(): Date {
  const [agora, setAgora] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setAgora(new Date()), 15_000);
    return () => clearInterval(t);
  }, []);
  return agora;
}

/**
 * Hora e data do cabeçalho do painel (at-130). O mesmo bloco nas duas visões da Home e no telão
 * em tela cheia — é parte do que mantém as abas na mesma altura ao alternar.
 */
const Relogio: React.FC<{ className: string; agora?: Date }> = ({ className, agora }) => {
  const proprio = useRelogio();
  const data = agora ?? proprio;
  return (
    <div className={className}>
      <b>{data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}</b>
      <span>{data.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' })}</span>
    </div>
  );
};

export default Relogio;
